import {AnswerType} from "@/entities/questionaire/answers/AnswerType";
import { AnswerVariant } from "./AnswerVariant";

export abstract class Answer {
    PropertyId: number = 0;
    variants?: AnswerVariant[];

    protected constructor(PropertyId: number, variants?: AnswerVariant[]) {
        this.PropertyId = PropertyId;
        this.variants = variants;
    }

    abstract getType(): AnswerType;
    abstract isEmpty(): boolean;
    abstract getComponentName(): string;
    abstract getQuizResultObject(): any;
}
